var indentStyle = {"indentZero":"TI-xX","indentOne":"k2m-h","indentTwo":"ieZjg","indentThree":"Si8vy","indentFour":"BX9Is","indentFive":"RH0E8","indentSix":"_6F4o7"};

export { indentStyle as i };
//# sourceMappingURL=indentation-b1f5c3c0.js.map
